export enum WebViewEvents {
	ADJUST_EVENT = 'log_event_adjust',
	NAVIGATE_BACK = 'navigate_back',
	NAVIGATE_HOME = 'navigate_home',
	NAVIGATE_TO_PAYPAL = 'navigate_to_paypal',
	NAVIGATE_TO_STAKE_ALL = 'navigate_to_stake_all',
	NAVIGATE_TO_STAKING = 'navigate_to_staking',
	NAVIGATE_TO_STAKING_TRANSACTION = 'navigate_to_staking_transaction',
	NAVIGATE_TO_TOP_UP = 'navigate_top_up',
	NAVIGATE_TO_TRANSACTION_DETAILS_CURRENCY_SCREEN = 'navigate_to_transaction_details_currency_screen',
	NAVIGATE_TO_TRANSACTION_DETAILS_FANTOKEN_SCREEN = 'navigate_to_transaction_details_fantoken_screen',
	NAVIGATE_TO_TRANSACTION_DETAILS_NFT_SCREEN = 'navigate_to_transaction_details_nft_screen',
	NAVIGATE_TO_WALLET_SCREEN = 'navigate_to_wallet_screen',
	TOP_UP_EVENT = 'log_event_top_up'
}
